import React, { useContext, useReducer, useEffect, useMemo } from 'react'
import { Box, TextField, Typography } from '@mui/material';
import { lockedReducer } from '../Utils/reducers';
import ColorButton from '../Buttons/ColorButton';
import Table, { TableHookPro } from '../Table';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import MegaAutoComplete from '../Utils/megautocomplete';
import { externalComponent } from '../AppRoutes';
import { api } from '../../services/api';
import clsx from 'clsx';
import './style.css'
import PrintToPDF from '../Utils/Print2Pdf';
import RelatorioEstoque from '../Relatorios/relatorio_estoque';
import toast from 'react-hot-toast';
import generateEstoqueReport from '../Utils/Print2Pdf2';

const getcolumnsConsultaEstoqueCodigo = (state) => {
    const columns = []
    columns.push({
        field: 'aro', headerName: 'Aro', flex: 0.1, width: 70,
        cellClassName: () => {
            return clsx('default-app bold', {
                selected: true,
            });
        }
    })
    columns.push({
        field: 'GrupoSimilaridade', headerName: 'Medida', width: 80,
        align: 'left',
        cellClassName: () => {
            return clsx('default-app bold align-start', {
                selected: true,
            });
        }
    })

    if (state.visualizacaoFilter == '1') {

        columns.push({
            field: 'id', headerName: 'Código', flex: 0.1, width: 70,
            cellClassName: () => {
                return clsx('center-cell', {
                    selected: true,
                });
            }
        })

        columns.push({ field: 'Descricao', headerName: 'Descrição', flex: 1 })

    }

    columns.push({
        field: 'totalEstoque', headerName: 'Estoque', width: 120,
        cellClassName: () => {
            return clsx('center-cell bold', {
                selected: true,
            });
        }
    })

    // Calcula colunas com estoque > 0
    for (let i = 0; i < state.columnsUF.length; i++) {
        const uf = state.columnsUF[i]

        // Soma os valores de estoque da coluna `uf` nas `rows`
        const total = state.rows.reduce((acc, row) => {
            const value = row[uf]
            return acc + (typeof value === 'number' ? value : 0)
        }, 0)

        // Só adiciona se o total for > 0
        if (total > 0) {
            columns.push({
                field: uf, headerName: uf, width: 70,
                cellClassName: () => {
                    return clsx('center-cell', {
                        selected: true,
                    });
                }
            })
        }
    }

    if (state.visualizacaoFilter == '1') {
        columns.push({
            field: 'marca', headerName: 'Marca', width: 100,
        })
    }

    return columns
}


const getColumnsUF = async (setLoader, setState) => {
    setLoader(true)
    const res = await api.get(`/consulta_empresas_uf/`)
    if (res.status === 200) {
        setState({ columnsUF: res.data })
    }
    setLoader(false)
}

const getConsultaEstoque = async (setLoader, setState, state) => {
    setLoader(true)
    const res = await api.post(`/consulta_estoque/`, state)
    if (res.status === 200) {
        setState({ rows: res.data.rows, rowsReset: res.data.rows, qtdeTotal: res.data.qtdeTotal })
    }
    setLoader(false)
    getColumnsUF(setLoader, setState)
}

const changeCodAble = (setState, value) => {

    if (value === '2') {
        setState({ codigoDisabled: true, codigoFilter: '', descricaoProdutoFilter: '', marcaFilter: '' })
    } else {
        setState({ codigoDisabled: false })
    }
}


const clearFilter = (state, setState, setLoader) => {
    setLoader(true)
    const clearFilters = {
        empresaFilter: '', codigoFilter: '', descricaoProdutoFilter: '', aroFilter: '',
        medidaFilter: '', marcaFilter: '', visualizacaoFilter: state.visualizacaoFilter, mostrarFilter: '1'
    }
    setState(clearFilters)
    getConsultaEstoque(setLoader, setState, clearFilters)
    getColumnsUF(setLoader, setState)
    setLoader(false)
}

const selectVisualizacao = {
    1: {
        "nome": "Código",
        "id": "1",
    },
    2: {
        "nome": "Medida",
        "id": "2",
    }
}

const selectMostrar = {
    1: {
        "nome": "Estoque total",
        "id": "1",
    },
    2: {
        "nome": "Estoque disponível",
        "id": "2",
    }
}


const handleEmpresa = (setState, data, setLoader, state) => {
    setState({ empresaFilter: data, nomeEmpresa: data?.label })
    const obj = {
        ...state,
        empresaFilter: data
    }
    getConsultaEstoque(setLoader, setState, obj)
}

const dataAtualPTBR = () => {
    const now = new Date();
    const dia = String(now.getDate()).padStart(2, '0');
    const mes = String(now.getMonth() + 1).padStart(2, '0'); // meses vão de 0 a 11
    const ano = now.getFullYear();
    const hora = String(now.getHours()).padStart(2, '0');
    const minuto = String(now.getMinutes()).padStart(2, '0');

    return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
}

const data_agora = dataAtualPTBR();

const PrintRelatory = (state) => {

    if (state.empresaFilter !== "" && state.empresaFilter !== null) {
        const paginas = [
            [
                {
                    tipo: "aro",
                    aro: "ARO 13",
                    produtos: state.rows,
                },
                ...state.rows.map((p) => ({
                    tipo: "produto",
                    produto: p,
                })),
            ],
        ];

        const data = new Date().toLocaleString("pt-BR");
        const user = localStorage.getItem('user').replace(/"/g, '');

        generateEstoqueReport({
            empresa: state.nomeEmpresa,
            data: dataAtualPTBR(),
            user: user,
            rows: state.rows
        });
    } else {
        toast.error("Selecione uma empresa primeiro antes de imprimir");
    }
};


const ConsultaEstoque = () => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        nomeEmpresa: '',
        empresaFilter: '',
        visualizacaoFilter: '1',
        mostrarFilter: '1',
        codigoFilter: '',
        descricaoProdutoFilter: '',
        aroFilter: '',
        medidaFilter: '',
        marcaFilter: '',
        codigoDisabled: false,
        columnsUF: [],
        rowsReset: [],
        qtdeTotal: 0
    })

    const [tableConsultaEstoque] = TableHookPro()

    const { setLoader } = useContext(externalComponent)

    useEffect(() => {
        getConsultaEstoque(setLoader, setState, state)
        getColumnsUF(setLoader, setState)
    }, [state.visualizacaoFilter])

    return (
        <>
            <Box className='nfsentrada-mainframe' sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%', minHeight: '1rem', height: '100%', overflow: 'auto', overflowX: 'hidden' }}>

                <Box sx={{ flex: .15 }} className='nfsentrada-filters'>

                    <Box className='filter-items' sx={{ marginBottom: '2rem', alignItems: 'flex-end' }}>
                        <Box className='item-profile-row' sx={{ width: '16rem' }} >
                            <MegaAutoComplete

                                id="consultaEstoqueEmpresa"
                                multiple={false}
                                value={state.empresaFilter}
                                onChange={(data) => handleEmpresa(setState, data, setLoader, state)}
                                noOptionsText={'Digite para procurar uma empresa'}
                                timeoutUrl='/frete/filiais/renamed/'
                                timeoutParam='label'
                                label='Empresa'
                            />
                        </Box>

                        <FormControl size="small" fullWidth={false} sx={{ width: '8rem' }}>
                            <InputLabel id="status-label">Visualização por:</InputLabel>
                            <Select
                                fullWidth={false}
                                id="consultaEstoqueVisualizacao"
                                labelId="consultaEstoqueVisualizacao-label"
                                value={state.visualizacaoFilter}
                                label="Visualização por:"
                                onChange={(e) => { setState({ 'visualizacaoFilter': e.target.value }); changeCodAble(setState, e.target.value) }}
                            >
                                {
                                    Object.entries(selectVisualizacao).map(([key, value]) => (
                                        <MenuItem key={key} value={value.id}>{value.nome}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>

                        <FormControl size="small" fullWidth={false} sx={{ width: '10rem' }}>
                            <InputLabel id="status-label">Mostrar:</InputLabel>
                            <Select
                                fullWidth={false}
                                id="consultaEstoqueMostrar"
                                labelId="consultaEstoqueMostrar-label"
                                value={state.mostrarFilter}
                                label="Mostrar:"
                                onChange={(e) => { setState({ 'mostrarFilter': e.target.value }) }}
                            >
                                {
                                    Object.entries(selectMostrar).map(([key, value]) => (
                                        <MenuItem key={key} value={value.id}>{value.nome}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>

                        <Box className='item-profile-row'>
                            <TextField
                                id="codigoFilter"
                                type="text"
                                label="Código"
                                value={state.codigoFilter}
                                onChange={(e) => { setState({ 'codigoFilter': e.target.value }) }}
                                fullWidth={false}
                                size='small'
                                inputProps={{
                                    maxLength: 20
                                }}
                                sx={{ width: '9rem' }}
                                disabled={state.codigoDisabled}
                            />
                        </Box>

                        <Box className='item-profile-row'>
                            <TextField
                                id="descricaoProdutoFilter"
                                type="text"
                                label="Descrição produto"
                                value={state.descricaoProdutoFilter}
                                onChange={(e) => { setState({ 'descricaoProdutoFilter': e.target.value }) }}
                                fullWidth={false}
                                size='small'
                                inputProps={{
                                    maxLength: 20
                                }}
                                sx={{ width: '11rem' }}
                                disabled={state.codigoDisabled}
                            />
                        </Box>

                        <Box className='item-profile-row'>
                            <TextField
                                id="marcaFilter"
                                type="text"
                                label="Marca"
                                value={state.marcaFilter}
                                onChange={(e) => { setState({ 'marcaFilter': e.target.value }) }}
                                fullWidth={false}
                                size='small'
                                inputProps={{
                                    maxLength: 20
                                }}
                                sx={{ width: '9rem' }}
                                disabled={state.codigoDisabled}
                            />
                        </Box>

                        <Box className='item-profile-row'>
                            <TextField
                                id="aroFilter"
                                type="text"
                                label="Aro"
                                value={state.aroFilter}
                                onChange={(e) => { setState({ 'aroFilter': e.target.value }) }}
                                fullWidth={false}
                                size='small'
                                inputProps={{
                                    maxLength: 20
                                }}
                                sx={{ width: '9rem' }}
                            />
                        </Box>

                        <Box className='item-profile-row'>
                            <TextField
                                id="medidaFilter"
                                type="text"
                                label="Medida"
                                value={state.medidaFilter}
                                onChange={(e) => { setState({ 'medidaFilter': e.target.value }) }}
                                fullWidth={false}
                                size='small'
                                inputProps={{
                                    maxLength: 20
                                }}
                                sx={{ width: '9rem' }}
                            />
                        </Box>


                    </Box>

                    <Box className='filter-buttons' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>

                        <Box>
                            <ColorButton onClick={() => PrintRelatory(state)}>
                                Imprimir PDF
                            </ColorButton>
                        </Box>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>

                            <Typography sx={{ fontWeight: 'bold', marginRight: '2rem' }}>
                                Qtde Total Estoque: {state.qtdeTotal}
                            </Typography>

                            <ColorButton onClick={() => getConsultaEstoque(setLoader, setState, state)}>
                                Localizar
                            </ColorButton>

                            <ColorButton onClick={() => clearFilter(state, setState, setLoader)}>
                                Limpar filtros
                            </ColorButton>
                        </Box>
                    </Box>

                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '1rem', flex: .85, height: '20rem' }}>
                    <Table
                        key='consulta-estoque'
                        paginationMode='client'
                        className='contabil-grid'
                        rows={state.rows}
                        columns={useMemo(() => getcolumnsConsultaEstoqueCodigo(state))}
                        rowHeight={30}
                        pro={true}
                        innerRef={tableConsultaEstoque}
                        nameTable='tabelaConsultaEstoque'
                    />
                </Box>


            </Box>


            <Box sx={{ position: "fixed", left: "-999rem" }}>
                <Box
                    id="relatorio-estoque"
                    sx={{ position: "relative" }}
                >
                    <RelatorioEstoque rows={state.rows} empresa={state.nomeEmpresa} />
                </Box>
            </Box>

        </>
    )
}

export default ConsultaEstoque;